import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'circular-indicator',
  standalone: true,
  templateUrl: './circular-indicator.component.html',
  styleUrls: ['./circular-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircularIndicatorComponent {
  @Input() percentage = 0;
  @Input() size = 100;

  get normalizedSize(): number {
    const safeSize = Number(this.size);
    return Number.isFinite(safeSize) ? Math.max(16, safeSize) : 100;
  }

  get clampedPercentage(): number {
    const safePercentage = Number(this.percentage);
    if (!Number.isFinite(safePercentage)) {
      return 0;
    }

    return Math.max(0, Math.min(100, safePercentage));
  }

  get strokeWidth(): number {
    return Math.max(2, Math.round(this.normalizedSize * 0.04));
  }

  get trackStrokeWidth(): number {
    return this.strokeWidth / 3;
  }

  get radius(): number {
    return (this.normalizedSize - this.strokeWidth) / 2;
  }

  get center(): number {
    return this.normalizedSize / 2;
  }

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  get isIndeterminate(): boolean {
    return this.clampedPercentage === 0;
  }

  get dasharray(): string {
    if (this.isIndeterminate) {
      return `${this.circumference * 0.28} ${this.circumference}`;
    }

    return `${this.circumference}`;
  }

  get dashoffset(): number {
    if (this.isIndeterminate) {
      return this.circumference * 0.15;
    }

    return this.circumference * (1 - this.clampedPercentage / 100);
  }
}
